module.exports = __webpack_public_path__ + "media/images/stat-longest-streak-c8bfc6c9.svg";